/*Tps-report*/
if (window.location.pathname.includes("reports/payable")) {
  window.makeDatepickers = datepickers => {
    datepickers.each(function(index, element) {
      $(element).addClass("initialized");

      $(element).datepicker({
        uiLibrary: "bootstrap4",
        value: $(element).val(),
        minDate: new Date(),
        disableDaysOfWeek: [0, 6],
        showOtherMonths: true,
        change: function(e) {
          if (!e.currentTarget.value) return;

          $.ajax({
            url: "/api/report/payable/snooze",
            method: "post",
            data: { id: $(this).data("id"), date: e.currentTarget.value },
            dataType: "json",
            success: function(response) {
              if (!moment(response.snooze_date).isBetween(moment(range_start_date), moment(range_end_date), "days", "[]")) {
                $(e.currentTarget)
                  .closest("tr")
                  .remove();
              }

              message("Payable successfully snoozed.");
            }
          });
        }
      });
    });
  };

  // Date range picker
  let range_start_date = $("#startDatePicker").val();
  let range_end_date = $("#endDatePicker").val();

  $("#startDatePicker").datepicker({
    uiLibrary: "bootstrap4",
    iconsLibrary: "fontawesome",
    maxDate: function() {
      return $("#endDatePicker").val();
    },
    open: function() {
      $("#startDatePicker")
        .closest(".form-daterangepicker")
        .addClass("active");
    },
    close: function() {
      $("#startDatePicker")
        .closest(".form-daterangepicker")
        .removeClass("active");
    },
    change: function(e) {
      if (range_start_date !== e.currentTarget.value) {
        range_start_date = e.currentTarget.value;

        updateTable(
          $(".data-table.table-budget"),
          {
            start_date: range_start_date,
            end_date: range_end_date
          },
          window.app_data.budget_table_keys
        );

        updateTable(
          $(".data-table.table-status"),
          {
            start_date: range_start_date,
            end_date: range_end_date
          },
          window.app_data.table_keys
        );
      }
    }
  });

  $("#endDatePicker").datepicker({
    uiLibrary: "bootstrap4",
    iconsLibrary: "fontawesome",
    minDate: function() {
      return $("#startDatePicker").val();
    },
    open: function() {
      $("#endDatePicker")
        .closest(".form-daterangepicker")
        .addClass("active");
    },
    close: function() {
      $("#endDatePicker")
        .closest(".form-daterangepicker")
        .removeClass("active");
    },
    change: function(e) {
      if (range_end_date !== e.currentTarget.value) {
        range_end_date = e.currentTarget.value;

        updateTable(
          $(".data-table.table-budget"),
          {
            start_date: range_start_date,
            end_date: range_end_date
          },
          window.app_data.budget_table_keys
        );

        updateTable(
          $(".data-table.table-status"),
          {
            start_date: range_start_date,
            end_date: range_end_date
          },
          window.app_data.table_keys
        );
      }
    }
  });

  function updateTable(table, daterange, columns) {
    const newData = { ...table.data("post_data"), ...daterange };

    if (!$.fn.dataTable.isDataTable(table)) {
      console.error("Incorrect datatable component!");
      return;
    }

    table.DataTable().destroy();
    table.empty();
    let html = "<thead><tr>";
    let header = columns;
    for (let i in header) {
      html += `<td data-column="${i}" class="col-${i}">${header[i]}</td>`;
    }
    html += "</tr></thead>";
    table.html(html);
    table.data("post_data", newData);
    table.data("options", options);
    window.dataTableInstance(table);
    $("[name='payable_search']").trigger("keyup");
  }

  var options = {
    columnDefs: [
      {
        render: function(data, type, row) {
          return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
        },
        targets: "col-policyholder"
      },
      {
        render: function(data, type, row) {
          var checked = data ? "checked" : "";
          return "<input class='quickbooks' data-placement_id='" + row.placement_id + "' type='checkbox' " + checked + "/>";
        },
        targets: "col-quickbooks"
      },
      {
        render(data, type, row) {
          return "$" + window.formatMoney(data);
        },
        targets: "col-amount"
      },
      {
        render: function(data, type, row) {
          return `<div class="btn-group">
            <button class="btn btn-secondary datatable-command btn-payable-action">Action</button>
            <button class="btn btn-danger datatable-command btn-icon" data-id="${row.id}" data-type="delete"><i class="fas fa-trash-alt"></i></button>
          </div>`;
        },
        targets: "col-completed"
      },
      {
        render: function(data, type, row) {
          return `<div class="d-flex justify-content-center align-items-center">
            <div class="form-control-wrap form-datepicker">
              <input
                id="dp-${row.id}"
                type="text"
                name="snooze_date"
                data-id='${row.id}'
                class="form-control datepicker border-0"
                style="opacity:0;width:0;"
                value="${moment(row.snooze_date).format("MM/DD/YYYY")}"
              />
              <label for="dp-${row.id}" class='form-control-date-custom border-0 pr-0 mb-0'></label>
            </div>
          </div>`;
        },
        targets: "col-snooze_date"
      },
      {
        render: function(data, type, row) {
          const link = row.pdf_path
            ? `<a href="${window.location.origin +
                "/" +
                row.pdf_path}" target="_blank"><img class="pdf-icon" src="/images/pdf-icon.svg" alt="Download Invoice PDF" /></a>`
            : `<img class="pdf-icon empty" src="/images/pdf-icon.svg" alt="PDF Not Available" />`;

          return `<div class="text-center">${link}</div>`;
        },
        targets: "col-pdf_path"
      }
    ],
    infoCallback: function(settings, json) {
      window.makeDatepickers($(".form-control.datepicker:not('.initialized')"));
    },
    buttons: [{ extend: "excel", text: '<i class="fas fa-file-download"></i>' }],
    order: [[3, "asc"]]
  };

  $.each($(".data-table"), function() {
    $(this).data("options", options);
  });

  $(".data-table").on("change", ".quickbooks", function() {
    const data = {
      placement: {
        id: $(this).data("placement_id"),
        quickbooks: this.checked ? 1 : 0
      }
    };

    const $this = $(this);

    $.ajax({
      url: "/api/placement/update_quickbooks",
      method: "POST",
      data: data,
      dataType: "json",
      success: function(response) {
        $("[data-placement_id='" + $this.data("placement_id") + "']")
          .not($this)
          .prop("checked", $this.is(":checked"));
      },
      error: function(response) {}
    });
  });

  function getPayableData(data) {
    return new Promise((resolve, reject) => {
      const id = data.id;
      const property_id = data.property_id;

      $.ajax({
        url: `/api/payable_data/${id}?property_id=${property_id || ""}`,
        method: "GET",
        dataType: "json",
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  }

  $(".data-table").on("click", ".btn-payable-action", async function() {
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    Swal.fire({
      title: "Action Payables Request",
      allowOutsideClick: false,
      heightAuto: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const modalData = await getPayableData(data);

    Swal.fire({
      title: "Action Payables Request",
      html: `<div id="payableAction">
        <v-payable-action
          :payable="data.payable"
          :placement="data.placement"
          :adjusters="data.adjusters"
          :property="data.property"
          :budget="data.budget"
        ></v-payable-action>
      </div>`,
      icon: undefined,
      showCancelButton: true,
      confirmButtonColor: "#50C3CA",
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      cancelButtonText: "Cancel",
      reverseButtons: true,
      width: 1024,
      heightAuto: false,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      preConfirm: async () => {
        const payable = {
          payable_id: data.id,
          payable: { completed: 1 }
        };

        try {
          const result = await confirmUpdate(payable);
          table
            .DataTable()
            .row(tr)
            .remove()
            .draw();

          if (result.logs) {
            app.appendChangeLog(result.logs);
          }
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
          return false;
        }
      },
      onRender: () => {
        new Vue({
          el: `#payableAction`,
          data: { data: modalData }
        });

        $(".swal2-confirm").attr("disabled", $('[name="payable[qb_needed]"]:checked').length > 0);
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Submitted", "Placement payable data has submitted.", "success");
      }

      updateTable(
        $(".data-table.table-budget"),
        {
          start_date: range_start_date,
          end_date: range_end_date
        },
        window.app_data.budget_table_keys
      );

      updateTable(
        $(".data-table.table-status"),
        {
          start_date: range_start_date,
          end_date: range_end_date
        },
        window.app_data.table_keys
      );
    });
  });

  function confirmUpdate(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/api/payable_action?log=1`,
        method: "POST",
        data,
        dataType: "json",
        success: function(response) {
          resolve(response);
        },
        error: function(response) {
          reject(response);
        }
      });
    });
  }

  $(window).on("form-success", function(action, response) {
    if (response.logs) {
      app.appendChangeLog(response.logs);
    }
  });

  $("[name='payable_search']").on("keyup", function() {
    let val = $(this).val();
    $.each($(".data-table"), function() {
      $(this)
        .DataTable()
        .search(val)
        .draw();
    });
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/payable.js